import styled from 'styled-components'
import { easings } from '../../styles/vars/easings.style'

export const FullWidthCarouselItemMain = styled.div`
  height: 100%;
  opacity: ${props => (props.active ? 1 : 0)};
  pointer-events: none;
  position: ${props => (props.index === 0 ? `relative` : `absolute`)};
  right: 0;
  top: 0;
  transition: opacity 1s ${easings.inOut.quart};
  width: 100%;
`
